<template>
  <div id="pageRoot">
    <img id="title" class="pageElement" src="/pages/img/sordocas/svgCas18bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 67px; top: 142px">
      <p>Lee los globos</p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 67px; top: 191px">
      <p>
        Dibuja a los personajes<br />
        y escribe quién lo dijo
      </p>
    </span>
    <span class="normalTheme pageInstruction" style="left: 67px; top: 271px">
      <p>Sube fotos de tus dibujos.</p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">Serafín.</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">Los patos.</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">
      Los hermanos de Serafín.
    </p>

    <img
      id="globe1"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordocas/svgCas18Globe01.svg"
    />
    <img
      id="globe2"
      class="text-box-a pageElement hover-animation-a"
      src="/pages/img/sordocas/svgCas18Globe02.svg"
    />

    <uploaded-image
      class="image01 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
    ></uploaded-image>
    <uploaded-image
      class="image02 pageElement picture-slot hover-animation-b"
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
    ></uploaded-image>

    <div
      id="button01"
      style="position: absolute; margin-left: 2.5%; margin-top: 66%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="1"
      ></image-upload>
    </div>
    <div
      id="button02"
      style="position: absolute; margin-left: 2.5%; margin-top: 66%; z-index: 5"
    >
      <image-upload
        v-bind:page="$parent.page"
        v-bind:type="$parent.type"
        number="2"
      ></image-upload>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField02"
    />
  </div>
</template>
<style scoped>
#title {
  position: absolute;
  left: 68px;
  top: 50px;
}
#tag01 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 467px;
  top: 120px;
}
#tag02 {
  position: absolute;
  width: 230px;
  text-align: center;
  left: 737px;
  top: 120px;
}
#tag03 {
  position: absolute;
  width: 520px;
  text-align: center;
  left: 467px;
  top: 210px;
}
#globe1 {
  position: absolute;
  left: 91px;
  top: 359px;
  z-index: 5;
}
#globe2 {
  position: absolute;
  left: 544px;
  top: 352px;
  z-index: 5;
}
.image01 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 23px;
  top: 408px;
}
.image02 {
  position: absolute;
  width: 482px;
  height: 309px;
  left: 523px;
  top: 408px;
}
#button01 {
  width: 216px;
  height: 77px;
  left: 280px;
  top: 2px;
}
#button02 {
  width: 216px;
  height: 77px;
  left: 777px;
  top: 2px;
}
#inputField01 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 34px;
  top: 683px;
  z-index: 5;
}
#inputField02 {
  position: absolute;
  width: 226px;
  height: 31px;
  left: 536px;
  top: 683px;
  z-index: 5;
}
</style>

<script>
import ImageUpload from "../../../components/ImageUpload.vue";
export default {
  name: "App",
  components: {
    ImageUpload,
  },
};
</script>